export default "__VITE_ASSET__B$nrQaWS__"